import { Component, OnInit } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery-9';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {
  nccImages: NgxGalleryImage[];
  mentorImages: NgxGalleryImage[];
  opensourceImages: NgxGalleryImage[];
  eventsImages: NgxGalleryImage[];


  galleryOptions: NgxGalleryOptions[] = [
    {
      width: '100%',
      height: '400px',
      thumbnailsColumns: 4,
      imageAnimation: NgxGalleryAnimation.Slide,
      previewKeyboardNavigation: true,
      previewCloseOnClick: true
    },
    // max-width 800
    {
      breakpoint: 800,
      width: '100%',
      height: '600px',
      imagePercent: 80,
      thumbnailsPercent: 20,
      thumbnailsMargin: 20,
      thumbnailMargin: 20,
      previewKeyboardNavigation: true,
      previewCloseOnClick: true
    },
    // max-width 400
    {
      breakpoint: 400,
      height: '375px',
      preview: true,
      previewCloseOnClick: true
    }
  ];
  constructor() { }

  ngOnInit(): void {

    this.nccImages = [
      {
        small: 'assets/images/gallery/NCC/a.jpg',
        medium: 'assets/images/gallery/NCC/a.jpg',
        big: 'assets/images/gallery/NCC/a.jpg'
      },
      {
        small: 'assets/images/gallery/NCC/b.jpg',
        medium: 'assets/images/gallery/NCC/b.jpg',
        big: 'assets/images/gallery/NCC/b.jpg',
      },
      {
        small: 'assets/images/gallery/NCC/c.jpg',
        medium: 'assets/images/gallery/NCC/c.jpg',
        big: 'assets/images/gallery/NCC/c.jpg',
      },
      {
        small: 'assets/images/gallery/NCC/d.jpg',
        medium: 'assets/images/gallery/NCC/d.jpg',
        big: 'assets/images/gallery/NCC/d.jpg',
      },
      {
        small: 'assets/images/gallery/NCC/e.jpg',
        medium: 'assets/images/gallery/NCC/e.jpg',
        big: 'assets/images/gallery/NCC/e.jpg',
      },
      {
        small: 'assets/images/gallery/NCC/f.jpg',
        medium: 'assets/images/gallery/NCC/f.jpg',
        big: 'assets/images/gallery/NCC/f.jpg',
      },
      {
        small: 'assets/images/gallery/NCC/g.jpg',
        medium: 'assets/images/gallery/NCC/g.jpg',
        big: 'assets/images/gallery/NCC/g.jpg'
      },
      {
        small: 'assets/images/gallery/NCC/h.jpg',
        medium: 'assets/images/gallery/NCC/h.jpg',
        big: 'assets/images/gallery/NCC/h.jpg'
      },
      {
        small: 'assets/images/gallery/NCC/i.jpg',
        medium: 'assets/images/gallery/NCC/i.jpg',
        big: 'assets/images/gallery/NCC/i.jpg'
      },
      {
        small: 'assets/images/gallery/NCC/j.jpg',
        medium: 'assets/images/gallery/NCC/j.jpg',
        big: 'assets/images/gallery/NCC/j.jpg'
      },
    ];

    this.mentorImages = [
      {
        small: 'assets/images/gallery/Mentor/1.jpg',
        medium: 'assets/images/gallery/Mentor/1.jpg',
        big: 'assets/images/gallery/Mentor/1.jpg'
      },
      {
        small: 'assets/images/gallery/Mentor/2.jpg',
        medium: 'assets/images/gallery/Mentor/2.jpg',
        big: 'assets/images/gallery/Mentor/2.jpg'
      },
      {
        small: 'assets/images/gallery/Mentor/3.jpg',
        medium: 'assets/images/gallery/Mentor/3.jpg',
        big: 'assets/images/gallery/Mentor/3.jpg'
      },
      {
        small: 'assets/images/gallery/Mentor/4.jpg',
        medium: 'assets/images/gallery/Mentor/4.jpg',
        big: 'assets/images/gallery/Mentor/4.jpg'
      },
      {
        small: 'assets/images/gallery/Mentor/5.jpg',
        medium: 'assets/images/gallery/Mentor/5.jpg',
        big: 'assets/images/gallery/Mentor/5.jpg'
      },
      {
        small: 'assets/images/gallery/Mentor/6.jpg',
        medium: 'assets/images/gallery/Mentor/6.jpg',
        big: 'assets/images/gallery/Mentor/6.jpg'
      },
      {
        small: 'assets/images/gallery/Mentor/7.jpg',
        medium: 'assets/images/gallery/Mentor/7.jpg',
        big: 'assets/images/gallery/Mentor/7.jpg'
      }
    ];

    this.opensourceImages = [
      {
        small: 'assets/images/gallery/Opensource/1.jpg',
        medium: 'assets/images/gallery/Opensource/1.jpg',
        big: 'assets/images/gallery/Opensource/1.jpg'
      },
      {
        small: 'assets/images/gallery/Opensource/2.jpg',
        medium: 'assets/images/gallery/Opensource/2.jpg',
        big: 'assets/images/gallery/Opensource/2.jpg'
      },
      {
        small: 'assets/images/gallery/Opensource/3.jpg',
        medium: 'assets/images/gallery/Opensource/3.jpg',
        big: 'assets/images/gallery/Opensource/3.jpg'
      },
      {
        small: 'assets/images/gallery/Opensource/4.jpg',
        medium: 'assets/images/gallery/Opensource/4.jpg',
        big: 'assets/images/gallery/Opensource/4.jpg'
      },
      {
        small: 'assets/images/gallery/Opensource/5.jpg',
        medium: 'assets/images/gallery/Opensource/5.jpg',
        big: 'assets/images/gallery/Opensource/5.jpg'
      },
      {
        small: 'assets/images/gallery/Opensource/6.jpg',
        medium: 'assets/images/gallery/Opensource/6.jpg',
        big: 'assets/images/gallery/Opensource/6.jpg'
      }
    ];

    this.eventsImages = [
      {
        small: 'assets/images/gallery/Events/1.jpg',
        medium: 'assets/images/gallery/Events/1.jpg',
        big: 'assets/images/gallery/Events/1.jpg'
      },
      {
        small: 'assets/images/gallery/Events/2.jpg',
        medium: 'assets/images/gallery/Events/2.jpg',
        big: 'assets/images/gallery/Events/2.jpg'
      },
      {
        small: 'assets/images/gallery/Events/3.jpg',
        medium: 'assets/images/gallery/Events/3.jpg',
        big: 'assets/images/gallery/Events/3.jpg'
      },
      {
        small: 'assets/images/gallery/Events/4.jpg',
        medium: 'assets/images/gallery/Events/4.jpg',
        big: 'assets/images/gallery/Events/4.jpg'
      },
      {
        small: 'assets/images/gallery/Events/5.jpg',
        medium: 'assets/images/gallery/Events/5.jpg',
        big: 'assets/images/gallery/Events/5.jpg'
      },
      {
        small: 'assets/images/gallery/Events/6.jpg',
        medium: 'assets/images/gallery/Events/6.jpg',
        big: 'assets/images/gallery/Events/6.jpg'
      },
      {
        small: 'assets/images/gallery/Events/7.jpg',
        medium: 'assets/images/gallery/Events/7.jpg',
        big: 'assets/images/gallery/Events/7.jpg'
      },
      {
        small: 'assets/images/gallery/Events/8.jpg',
        medium: 'assets/images/gallery/Events/8.jpg',
        big: 'assets/images/gallery/Events/8.jpg'
      },
      {
        small: 'assets/images/gallery/Events/9.jpg',
        medium: 'assets/images/gallery/Events/9.jpg',
        big: 'assets/images/gallery/Events/9.jpg'
      },
      {
        small: 'assets/images/gallery/Events/10.jpg',
        medium: 'assets/images/gallery/Events/10.jpg',
        big: 'assets/images/gallery/Events/10.jpg'
      },
      {
        small: 'assets/images/gallery/Events/11.jpg',
        medium: 'assets/images/gallery/Events/11.jpg',
        big: 'assets/images/gallery/Events/11.jpg'
      },
      {
        small: 'assets/images/gallery/Events/12.jpg',
        medium: 'assets/images/gallery/Events/12.jpg',
        big: 'assets/images/gallery/Events/12.jpg'
      },
      {
        small: 'assets/images/gallery/Events/13.jpg',
        medium: 'assets/images/gallery/Events/13.jpg',
        big: 'assets/images/gallery/Events/13.jpg'
      },
      {
        small: 'assets/images/gallery/Events/14.jpg',
        medium: 'assets/images/gallery/Events/14.jpg',
        big: 'assets/images/gallery/Events/14.jpg'
      },
      {
        small: 'assets/images/gallery/Events/15.jpg',
        medium: 'assets/images/gallery/Events/15.jpg',
        big: 'assets/images/gallery/Events/15.jpg'
      }
    ];
  }

}
